import { supabase } from './supabase';

// Price alerts persisted in Supabase (table price_alerts, RLS-scoped to the
// owner). The scheduled function check-price-alerts.js evaluates active alerts
// server-side and sends a web-push; a fired alert is deactivated (one-shot).
// The client only loads active alerts and creates/removes them.

const toUi = (r) => ({
  id: r.id,
  symbol: r.symbol,
  direction: r.direction,
  targetPrice: Number(r.target_price),
});

export async function loadAlerts(userId) {
  if (!supabase || !userId) return [];
  const { data, error } = await supabase
    .from('price_alerts')
    .select('id, symbol, direction, target_price, created_at')
    .eq('user_id', userId)
    .eq('active', true)
    .order('created_at');
  if (error) {
    console.error('[alerts] load →', error.code, error.message);
    return [];
  }
  return (data || []).map(toUi);
}

export async function addAlert(userId, { symbol, direction, targetPrice }) {
  if (!supabase || !userId) return null;
  const { data, error } = await supabase
    .from('price_alerts')
    .insert({ user_id: userId, symbol, direction, target_price: targetPrice })
    .select('id, symbol, direction, target_price')
    .single();
  if (error) {
    console.error('[alerts] add →', error.code, error.message);
    return null;
  }
  return toUi(data);
}

export async function removeAlert(id) {
  if (!supabase || !id) return;
  const { error } = await supabase.from('price_alerts').delete().eq('id', id);
  if (error) console.error('[alerts] remove →', error.code, error.message);
}
